import { VmsRoutingModule } from './vms/vms-routing.module';
import { NotificationsComponent } from 'src/app/_Shared/_Components/_Generic/notifications/notifications.component'; //changes=d
// import { SearchPipe } from './pipes/search.pipe'; //changed
import { HttpInterceptorProvider } from 'src/app/_Core/_Interceptors/http-interceptor'; //changed
import { EmptyStateComponent } from 'src/app/_Shared/_Components/_Generic/error-pages/empty-state/empty-state.component';
import { CreditScoreComponent } from './credit-score/credit-score.component';
import { ForbiddenComponent } from 'src/app/_Shared/_Components/_Generic/error-pages/forbidden/forbidden.component'; // changed
import { NotFoundComponent } from 'src/app/_Shared/_Components/_Generic/error-pages/not-found/not-found.component'; // changed
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BookMeetingRoomComponent } from './meeting-room-TA/book-meeting-room/book-meeting-room.component';
import { BookingConfirmationComponent } from './meeting-room-TA/booking-confirmation/booking-confirmation.component';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OverviewComponent } from './overview/overview.component';
import { EmployeesModule } from './employees-TA/employees.module';
import { EmployeesRoutingModule } from './employees-TA/employees-routing.module';
import { LoginComponent } from 'src/app/_Shared/_Components/_Common/login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { ReportsComponent } from './reports/reports.component';
import { DatePipe } from '@angular/common';
import { MsAdalAngular6Module } from 'microsoft-adal-angular6';
import { environment } from '../environments/environment';
import { Ng2SearchFilterModule } from './_Shared/ng2-search-filter.module';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';  //changed
import { ToastMessage } from 'src/app/_Shared/_Components/_Generic/toast/toast.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgHttpLoaderModule } from 'ng-http-loader';
// import { ChangePasswordComponent } from './change-password/change-password.component'; //changed
import { VmsModule } from './vms/vms.module';
import { OverviewModuleComponent } from './overview-module/overview-module.component';
import { ParkiteReportsComponent } from './parkite-reports/parkite-reports.component';
import { TimerService } from 'src/app/_Core/_Services/timer.service';

//New import
import { SharedModuleNew } from 'src/app/_Shared/shared.module'

//Google re-captcha
// import { ReCaptchaService } from './re-captcha.service';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { BookNewMeetingRoomComponent } from './modal/book-new-meeting-room/book-new-meeting-room.component';
import { CancelMeetingroomBooking } from './modal/cancel-meetingroom-booking/cancel-meetingroom-booking.component';
import { SecurityPasswordResendComponent } from './modal/security-password-resend/security-password-resend.component';

import { AngularSvgIconModule } from 'angular-svg-icon';
import { MeetingroomCancelPortalComponent } from './modal/meetingroom-cancel-portal/meetingroom-cancel-portal.component';

@NgModule({
  declarations: [
    AppComponent,
    // EmptyStateComponent,
    BookMeetingRoomComponent,
    BookingConfirmationComponent,
    OverviewComponent,
    LoginComponent,
    ProfileComponent,
    ReportsComponent,
    NotFoundComponent,
    ForbiddenComponent,
    CreditScoreComponent,
    ToastMessage,
    // SearchPipe,
    NotificationsComponent,
    // ChangePasswordComponent,
    OverviewModuleComponent,
    ParkiteReportsComponent,
    BookNewMeetingRoomComponent,
    CancelMeetingroomBooking,
    SecurityPasswordResendComponent,
    MeetingroomCancelPortalComponent,

  ],
  imports: [
    NgxPaginationModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    // SharedModule,
    HttpClientModule,
    NgHttpLoaderModule.forRoot(),
    EmployeesModule,
    EmployeesRoutingModule,
    VmsRoutingModule,
    VmsModule,
    MsAdalAngular6Module.forRoot({
      domain: environment.domain,
      tenant: environment.tenant,
      clientId: environment.clientId,
      redirectUri: environment.redirectUri,
      endpoints: {
        "https://localhost/Api/": "xxx-bae6-4760-b434-xxx"
      },
      navigateToLoginRequestUrl: false,
      cacheLocation: '<localStorage / sessionStorage>',
      postLogoutRedirectUri: '/login',
    }),
    Ng2SearchFilterModule,

    //new imports
    SharedModuleNew,
    RecaptchaV3Module,
    AngularSvgIconModule.forRoot(),
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [],
  providers: [TimerService, DatePipe, {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptorProvider,
    multi: true
  },
    AppStateProvider,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      // useValue: '6LcI3FAoAAAAACBQYUtCeHLOHQHYb0_cH14XkYio',
      useValue: '6LecWl0oAAAAAG8ZBtmjv5ad6VWCsc0DcbC_M9BA',
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }
